/**
 * 华普专用api
 */
import Axios from '@/components/api/axios.js'

export default {
	/**
	 * 通过名字(全称或者一部分)和类型查询单位下所有的组
	 * type为2是配电房
	 */
	findClassByClassNoLikeNameAndType(unitId, nameChar, type, success, failure) {
		Axios.post('/huapu/findClassByClassNoLikeNameAndType.do', {
			unitId,
			nameChar,
			type
		}, success, failure)
	},
	/**
	 * 查询组下面的所有的变压器的台账信息，额定负荷是typepropertycode为Capacity的项
	 */
	findLoadDeviceByClassNo(classNo, success, failure) {
		Axios.post('/huapu/findLoadDeviceByClassNo.do', {
			classNo
		}, success, failure)
	},
	/**
	 * 获取组的尖峰平谷月度数据 华普定制版
	 * /huapu/getClassPGByMonthForHuaPu.do(旧接口)post
	 * /cost/findCostFromMonth(新接口)get
	 * 
	 */
	getClassPGByMonthForHuaPu(timeStamp, unitId, success, failure) {
		Axios.post('/huapu/getClassPGByMonthForHuaPu.do', {
			timeStamp,
			unitId
		}, success, failure)
	},
	/**
	 * 获取所有变量名称以channelstate.开头的实时值
	 */
	getChannelstateRTValue(success, failure) {
		Axios.post('/huapu/getChannelstateRTValue.do', {}, success, failure)
	},
}